import {
  Inject,
  Injectable,
  LOCALE_ID
} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { generateWatchlistFromBackendInput } from '../../watchlists/model/watchlist/watchlist.generators';
import { WatchlistSnapshot } from '../model/watchlist-snapshot';
import { WatchlistSnapshotBackendInterface } from '../model/watchlist-snapshot.backend-interface';


@Injectable()
export class WatchlistSnapshotsService {

  constructor(private _httpClient: HttpClient, @Inject(LOCALE_ID) private _locale: string) {}


  /**
   * Fetches a watchlist snapshot
   *
   * @param watchlistSnapshotUuid
   * @returns
   */
  getWatchlistSnapshot(watchlistSnapshotUuid: string): Observable<{snapshot: WatchlistSnapshot; subSnapshots?: WatchlistSnapshot[]}> {
    let url = `${ environment.api_url }watchlists/snapshots/${ watchlistSnapshotUuid }?locale=${ this._locale }`;
    if (environment.catalogIdentifier) {
      url += `&catalogIdentifier=${ environment.catalogIdentifier }`;
    }
    return this._httpClient.get<{watchlistSnapshot: WatchlistSnapshotBackendInterface}>(
      url
    ).pipe(
      map(response => {
        if (response.watchlistSnapshot) {
          const snapshots: {snapshot: WatchlistSnapshot; subSnapshots?: WatchlistSnapshot[]} = {
            snapshot: generateWatchlistFromBackendInput(response.watchlistSnapshot)
          };

          if (response.watchlistSnapshot.Watchlists) {
            snapshots.subSnapshots = response.watchlistSnapshot.Watchlists.map(generateWatchlistFromBackendInput);
          }
          return snapshots;
        } else {
          return null;
        }
      })
    );
  }
}
